import api from '@/apis'
import { API_PREFIX } from '@/constants'
import type { GetProductPaymentProcessResponse } from '@/payment/types'

/**
 * 토스/네이버 결과 조회 — `/sealed-vinyl/result?key=UUID`에서 호출.
 *
 * POST /product-payments/process로 저장된 결제 데이터를 key로 다시 받아서
 * 토스/네이버 콜백 API에 전달한다.
 */
export const apiGetProductPaymentProcess = async (key: string): Promise<GetProductPaymentProcessResponse> => {
  return api.get(`${API_PREFIX.PAYMENT}/product-payments/process/${key}`)
}
